import { render, staticRenderFns } from "./TechList.vue?vue&type=template&id=8dc8d2bc&scoped=true"
import script from "./TechList.vue?vue&type=script&lang=js"
export * from "./TechList.vue?vue&type=script&lang=js"
import style0 from "./TechList.vue?vue&type=style&index=0&id=8dc8d2bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dc8d2bc",
  null
  
)

export default component.exports